import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  profile: {},
  integrations: []
}

export default {
  state,
  getters,
  mutations,
  actions
}
